<!--  -->
<template>
  <div class="box">
    <div  class="newsviews">
        <div class="tab">
        企业推荐
      </div>
      <div class="sevices">
        <div class="item" v-for="ad in imgAd" :key="ad.id">
        <a :href="ad.url">
          <img :src="`${IP_TEST}/uploads/${ad.picsrc}`" width="290" height="101" :alt="ad.name"  />
        </a>
        
      </div>
      </div>
        
    </div>
     
  </div>
</template>

<script>
import { IP_TEST } from '@/config'
import { getAdsOfType } from '@/request/get'
export default {
  data () {
    return {
        IP_TEST,
        imgAd:[]
    };
  },

  computed(){},

  mounted(){
    this.getAds();
  },

  methods: {
    async getAds(){
        let result = await getAdsOfType('企业推荐');
        this.imgAd = result.data || [];
    }
  }
}

</script>
<style scoped>
.box{
  position: relative;
  width: 100%;
  margin: 0 auto;
  background-color: #fff;
}
.newsviews{
  position: relative;
  width: 1300px;
  /* min-height: 1166px; */
  margin: 0 auto;
  overflow: hidden;
   
}
.sevices{
 height: 278px;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  align-items:start;
      position: relative;
}
.item{
  width: 290px;
  height: 101px;
  margin-bottom: 14px;
}
.item:hover{
  cursor: pointer;
}
.newsviews .tab{
font-size: 28px;
font-family: PingFang SC;
font-weight: 500;
color: #333333;
margin-top: 38px;;
margin-bottom:20px;
/* line-height: 155px; */
}
</style>